import styled from 'styled-components';

const DeleteConfirmationDialog = styled.div`
  color: var(--greyscale-blackish);

  .delete-confirmation-footer {
    display: flex;
    justify-content: space-between;
  }
`;

export default DeleteConfirmationDialog;
